export default {
  computed: {
    $localCurrency () {
      var allCurrencies = this.$store.state.CurrencyStore.all_currencies
      var localCurrency = this.$store.state.CurrencyStore.browser_currency.toLowerCase()
      var sign = ''
      allCurrencies.find(function (currency) {
        if (currency.currency_name.toLowerCase() === localCurrency) {
          sign = currency.currency_sign
        }
      })
      return sign
    },
    $loadingTrue () {
      return this.$store.state.LoadingStore.loading
    },
    currency: function() {
      return this.$store.state.CurrencyStore.browser_currency;
    },
   
  },
  methods: {
    $roundOff: function (number) {
      return Math.ceil(number).toLocaleString('en')
    },
    $imageUniversalUrl: function () {
      // http://165.227.117.249 Development
      // https://167.99.85.35 Production
      // return 'https://0a13-41-84-135-252.ngrok.io'
      return 'https://bookings.olpejetaconservancy.org'
      // return 'https://bc87-41-84-135-252.ngrok.io'

    }
  }
}
